import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import Storefront from './components/Storefront';
import Dashboard from './components/Dashboard';
import Impact from './components/Impact';

// 1. INITIALIZE STRIPE (Use your pk_test_ key)
const stripePromise = loadStripe('pk_test_51TDhGQ0229WQ63FBaM86MT50ZVI4AVfmSa0w3l2jBAOzM7XMM0mqItc24TI8mVZ8jIEnMJmOMxp3TI3IcZyNxwjD00JCfHfkMA');

function App() {
  const [view, setView] = useState(window.location.pathname);
  
  // 2. PRODUCT STATE
  const [products, setProducts] = useState(() => {
    const hardCoded = [
      { 
        id: 1, 
        name: 'MIGHTY HOODIE', 
        price: 85, 
        color: 'Midnight Blue',
        image: 'https://i.postimg.cc/w3KPVc4z/Gemini_Generated_Image_80kffb80kffb80kf.png',
        stripePriceId: 'price_1TDhrx0229WQ63FBYoWhTrLR' 
      },
      { 
        id: 2, 
        name: 'TMN CAP', 
        price: 45, 
        color: 'Arctic White',
        image: 'https://i.postimg.cc/T1xTQ5tg/2d433420_243d_11f1_ab29_01c105d570ac.png',
        stripePriceId: 'price_123_EXAMPLE_CAP' 
      }
    ];

    const saved = localStorage.getItem('mighty_products');
    if (saved) {
      const parsedSaved = JSON.parse(saved);
      const newDrops = parsedSaved.filter(sp => !hardCoded.find(hp => hp.id === sp.id));
      return [...hardCoded, ...newDrops];
    }
    return hardCoded;
  });
  
  const [orders, setOrders] = useState(() => {
    const saved = localStorage.getItem('mighty_orders');
    return saved ? JSON.parse(saved) : [];
  });

  // 3. CHECKOUT LOGIC (Multi-item support)
  const handleCheckout = async (cartItems) => {
    const stripe = await stripePromise;

    if (!cartItems || cartItems.length === 0) return;

    // Convert cart to Stripe format
    const lineItems = cartItems.map(item => ({
      price: item.stripePriceId,
      quantity: 1,
    }));

    // Verify all items have IDs
    const invalidItems = cartItems.filter(item => !item.stripePriceId || item.stripePriceId.includes('EXAMPLE'));
    if (invalidItems.length > 0) {
      alert(`Missing Stripe IDs for: ${invalidItems.map(i => i.name).join(', ')}`);
      return;
    }

    const { error } = await stripe.redirectToCheckout({
      lineItems: lineItems,
      mode: 'payment',
      successUrl: `${window.location.origin}/?payment=success`,
      cancelUrl: `${window.location.origin}/`,
    });

    if (error) {
      console.error("Stripe Error:", error.message);
      alert(error.message);
    }
  };

  // 4. SUCCESS NOTIFICATION
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    if (query.get('payment') === 'success') {
      alert("PAYMENT SUCCESSFUL. WELCOME TO THE FAMILY.");
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  // 5. NAVIGATION & PERSISTENCE
  useEffect(() => {
    localStorage.setItem('mighty_products', JSON.stringify(products));
    localStorage.setItem('mighty_orders', JSON.stringify(orders));
  }, [products, orders]);

  useEffect(() => {
    const handlePopState = () => setView(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const totalRevenue = orders.reduce((sum, order) => sum + order.price, 0);
  const impactAmount = (totalRevenue * 0.10).toFixed(2);

  const renderContent = () => {
    switch (view) {
      case '/mighty-vault-99':
        return <Dashboard orders={orders} products={products} setProducts={setProducts} />;
      case '/impact':
        return <Impact impactAmount={impactAmount} />;
      default:
        return <Storefront products={products} onCheckout={handleCheckout} />;
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans flex flex-col">
      <main className="flex-grow">{renderContent()}</main>
      <footer className="py-12 border-t border-slate-100 bg-white">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] font-black uppercase tracking-widest">
          <div className="text-slate-400">© 2026 THE MIGHTY NAME</div>
          <nav className="flex gap-8 text-slate-600">
            <a href="/">Store</a>
            <a href="/impact">Impact</a>
            <a href="mailto:support@themightyname.com">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default App;